import React from "react";
import { getRequester, userRole, filterPendingInvitations, getUserByCognitoId } from "../../functions/FilterUsers";
import { t } from "i18next";
import "./PendingInvitations.scss";
import { formatDateToView } from "../../functions/DateTime";
import { Link } from "react-router-dom";

interface PendingInvitationsProps {
  feedbacks: IFeedback[];
  userId: string;
}

export function PendingInvitations({ feedbacks, userId }: PendingInvitationsProps) {
  const pendingInvitations = filterPendingInvitations(feedbacks, userId);

  if (pendingInvitations.length === 0) {
    return null;
  }

  return (
      <div className="border border-secondary rounded-3 pb-0 w-100 mb-4">
          {pendingInvitations.map(feedback => (
            <div className="d-flex flex-column flex-md-row gap-3 gap-md-0 justify-content-md-between p-3 align-items-center" key={feedback.id}>
              <div className="">
                <h3 className="title mb-0"><strong>{getRequester(feedback.users)?.name}</strong> {t("feedbackList.invited.message")} <strong>{t(`feedbackRoles.${userRole(feedback)}`)}</strong>!</h3>
              </div>
              <div className="d-flex align-items-center gap-2">
                <p className="text-secondary mb-0 text-nowrap">
                  {`${formatDateToView(feedback.schedule_date)} ${t("feedbackDate.preposition")} ${feedback.schedule_time}`}
                </p>
                <Link
                  to={`/feedbacks/${feedback.id}/accept_invitation/${getUserByCognitoId(userId, feedback.users)?.invitation?.code || ''}`}
                  className="btn btn-outline-secondary w-100 button-show-invitation"
                >
                  {t("feedbackList.actions.showInvitation")}
                </Link>
              </div>
            </div>
          ))}
      </div>
  )
}
